import React, { useEffect, useState } from "react";
import styles from "./Login.module.css";
import Button from "../../Components/Forms/Button";
import { useNavigate, useSearchParams } from "react-router-dom";
import { isLoggedIn } from "../../Auth/auth";
import Snackbar from "../../Components/Snackbar/Snackbar";
import icon from "../../Assets/google-icon.png";
import { PATH } from "../../PATH";
import logo from "../../Assets/Defensoria_logo.png";
import { Button as GetiButton } from "@geti/identidade-visual-react";

const Login = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showGoogleNotRegistered, setShowGoogleNotRegistered] = useState(false);
  const [showGoogleAccountDisabled, setShowGoogleAccountDisabled] =
    useState(false);
  const [showOauthCallbackError, setShowOauthCallbackError] = useState(false);

  useEffect(() => {
    if (isLoggedIn()) {
      navigate("/agendar");
    }
  }, [navigate]);

  useEffect(() => {
    const googleErr = searchParams.get("google_error");
    if (googleErr === "not_registered") {
      setShowGoogleNotRegistered(true);
      const next = new URLSearchParams(searchParams);
      next.delete("google_error");
      setSearchParams(next, { replace: true });
    } else if (googleErr === "account_disabled") {
      setShowGoogleAccountDisabled(true);
      const next = new URLSearchParams(searchParams);
      next.delete("google_error");
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (searchParams.get("oauth_error") === "missing_tokens") {
      setShowOauthCallbackError(true);
      const next = new URLSearchParams(searchParams);
      next.delete("oauth_error");
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return (
    <div className={styles.container}>
      {showGoogleNotRegistered && (
        <Snackbar
          type="googleLoginNotRegistered"
          setSnackbarType={() => setShowGoogleNotRegistered(false)}
        />
      )}
      {showGoogleAccountDisabled && (
        <Snackbar
          type="googleLoginAccountDisabled"
          setSnackbarType={() => setShowGoogleAccountDisabled(false)}
        />
      )}
      {showOauthCallbackError && (
        <Snackbar
          type="oauthCallbackMissingTokens"
          setSnackbarType={() => setShowOauthCallbackError(false)}
        />
      )}
      <div className={styles.backdrop} aria-hidden />
      <div className={styles.card}>
        <div className={styles.accent} />
        <div className={styles.brandBlock}>
          <img
            src={logo}
            alt="Logo da Defensoria do Estado de Santa Catarina"
            className={styles.logo}
          />
          <span className={styles.productName}>ATOS</span>
        </div>
        <h1 className={styles.title}>Bem-vindo(a)</h1>
        <p className={styles.subtitle}>
          Entre com sua conta Google para agendar e gerenciar publicações no
          sistema.
        </p>
        <form
          action={`${PATH.baseApi}/google-redirect/`}
          method="get"
          className={styles.form}
        >
          <Button type="submit" className={styles.google}>
            <img
              alt=""
              src={icon}
              className={styles.icon}
              width={22}
              height={22}
            />
            <span className={styles.googleLabel}>Acessar com Google</span>
          </Button>
        </form>
          <GetiButton className={"text-medium text-muted-foreground hover:text-foreground hover:underline"} type="button" variant="link" onClick={() => navigate("/")}>
            Acessar a lista de Atos
          </GetiButton>
        <p className={styles.footerNote}>
          O acesso é restrito a usuários previamente cadastrados.
        </p>
      </div>
    </div>
  );
};

export default Login;
